export default __webpack_public_path__ + "5737219f88cf3dc6e2f9f5e64b3806b5.svg";